
export interface Currency {
  id: number;
  name: string;
  isoCode: string;
  createdOn?: string;
  modifiedOn?: string;
  countryFlag?: string | null;
  isRefCurrency?: boolean;
  currentCurrencyExchange?: CurrencyExchange | null;
  odooEntityId?: number | null;
}

export interface CurrencyExchange {
  id: number;
  price: number;
  baseRate: number;
  startDate: Date;
  currencyId: number;
}
